<template>
	<div>
		<v-data-table
			v-if="hasItens"
			:items="tipos"
			:headers="colunas"
			item-key="id"
			hide-default-footer
			:server-items-length="totalItens"
			:options="paginacaoInterna"
			class="arp-listview mt-5 row-pointer"
		>
			<template #item.tipo="{ item }">
				<texto-tooltip :texto="item.nome" :tamanho-maximo="tipoTamanhoMaximo"></texto-tooltip>
			</template>
			<template #item.dataCadastro="{ item }">
				<span>{{ item.dataCadastro | formatDataFilter }}</span>
			</template>
			<template #item.areaPublica="{ item }">
				<span>{{ getOpcaoSimNao(getInformacaoAreaPublicaEObrigatorio(item)) }}</span>
			</template>
			<template #item.situacao="{ item }">
				<span> {{ filtrarSituacao(item.situacao) }} </span>
			</template>
			<template #item.acoes="{ item }">
				<tipo-documento-listagem-botoes-acoes
					:id-tipo-documento="item.id"
					@abrir-modal-editar="abrirFecharModalEdicaoTipoDocumento(item)"
					@abrir-modal-excluir="abrirFecharModalExcluirTipoDocumento"
					@abrir-modal-validacao-tramitacao="abrirFecharModalValidacaoTramitacao"
				></tipo-documento-listagem-botoes-acoes>
			</template>
		</v-data-table>
		<paginacao-tabela
			v-if="hasItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:total-paginas="totalPaginas"
			:total-itens="totalItens"
			@resetar-page="resetarPage"
		></paginacao-tabela>
		<template-listagem-vazia :total-itens="totalItens" :textos="textoListagemVazia"></template-listagem-vazia>

		<modal-confirmacao
			id="excluir"
			:exibir="exibirModalExclusao"
			:mensagem="mensagemExclusao"
			@fechar-modal="abrirFecharModalExcluirTipoDocumento"
			@confirmar="confirmarExcluirTipoDocumento"
			:subtitulo-modal="subtituloModalExclusao"
			:titulo-modal="tituloModalExclusao"
		></modal-confirmacao>
		<editar-tipo-documento
			v-if="exibirModalEditar"
			:exibir="exibirModalEditar"
			:tipo-documento="tipoDocumentoEdicao"
			@fechar-modal="abrirFecharModalEdicaoTipoDocumento"
			@recarregar-listagem-tipo-documento="resetarPage"
		></editar-tipo-documento>
		<modal-validacao-tramitacao
			v-if="exibirModalValidacaoTramitacao"
			:exibir="exibirModalValidacaoTramitacao"
			:id-tipo-documento="idTipoDocumentoValidacaoTramitacao"
			@fechar-modal="abrirFecharModalValidacaoTramitacao"
		></modal-validacao-tramitacao>
	</div>
</template>

<script>
import { TabelaColunaUtils } from '@/core/utils'
import tabelaMixin from '@/views/mixins/tabela'
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import { actionTypes, opcaoSimNao, situacoes } from '@/core/constants'
import situacaoFilter from '@/views/filters/situacao-filter'
import PaginacaoTabela from '@/views/components/PaginacaoTabela.vue'
import TemplateListagemVazia from '@/views/components/TemplateListagemVazia.vue'
import TipoDocumentoListagemBotoesAcoes from '@/views/pages/configuracao/tipo-documento/listagem/botoes-acoes/TipoDocumentoListagemBotoesAcoes.vue'
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'
import EditarTipoDocumento from '@/views/pages/configuracao/tipo-documento/listagem/editar-tipo/EditarTipoDocumento.vue'
import ModalValidacaoTramitacao from '@/views/pages/configuracao/tipo-documento/modal-validacao-tramitacao/ModalValidacaoTramitacao.vue'

export default {
	name: 'tipo-documento-listagem',
	components: {
		EditarTipoDocumento,
		ModalConfirmacao,
		TipoDocumentoListagemBotoesAcoes,
		TemplateListagemVazia,
		PaginacaoTabela,
		TextoTooltip,
		ModalValidacaoTramitacao,
	},
	mixins: [tabelaMixin],
	props: {
		tipos: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			colunas: [
				new TabelaColunaUtils('Tipo', 'tipo', '60%'),
				new TabelaColunaUtils('Criação', 'dataCadastro'),
				new TabelaColunaUtils('Área Pública', 'areaPublica'),
				new TabelaColunaUtils('Situação', 'situacao'),
				new TabelaColunaUtils('Ações', 'acoes'),
			],
			textoListagemVazia: {
				titulo: 'Nenhum tipo de documento foi encontrado',
			},
			tipoTamanhoMaximo: 50,
			paginacaoInterna: this.paginacao,
			exibirModalExclusao: false,
			mensagemExclusao: 'Deseja realmente confirmar esta ação?',
			subtituloModalExclusao: 'Após a confirmação ele será removido!',
			tituloModalExclusao: 'Atenção! Você está prestes a remover um Tipo de Documento!',
			idTipoDocumentoExclusao: null,
			tipoDocumentoEdicao: null,
			exibirModalEditar: false,
			idTipoDocumentoValidacaoTramitacao: null,
			exibirModalValidacaoTramitacao: false,
		}
	},
	methods: {
		getInformacaoAreaPublicaEObrigatorio(item) {
			return item.areaPublica === 'SIM' && item.areaPublicaObg === 'SIM' ? 'SIM' : 'NAO'
		},
		getOpcaoSimNao(opcao) {
			return opcaoSimNao[opcao].text
		},
		filtrarSituacao(situacao) {
			return situacaoFilter(situacao, situacoes.TIPO_DOCUMENTO)
		},
		async resetarPage() {
			await this.$emit('resetar-page')
			await this.$emit('recarregar-listagem-tipo-documento')
		},
		abrirFecharModalExcluirTipoDocumento(idTipoDocumento) {
			this.idTipoDocumentoExclusao = idTipoDocumento
			this.exibirModalExclusao = !this.exibirModalExclusao
		},
		async confirmarExcluirTipoDocumento() {
			await this.$store.dispatch(
				actionTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.EXCLUIR_TIPO_DOCUMENTO,
				this.idTipoDocumentoExclusao,
			)

			this.mostrarNotificacaoSucesso('Tipo de documento removido com sucesso.')
			this.abrirFecharModalExcluirTipoDocumento()
			await this.resetarPage()
		},
		abrirFecharModalEdicaoTipoDocumento(tipoDocumento) {
			this.tipoDocumentoEdicao = tipoDocumento
			this.exibirModalEditar = !this.exibirModalEditar
		},
		abrirFecharModalValidacaoTramitacao(idTipoDocumento) {
			this.idTipoDocumentoValidacaoTramitacao = idTipoDocumento
			this.exibirModalValidacaoTramitacao = !this.exibirModalValidacaoTramitacao
		},
	},
}
</script>

<style scoped lang="stylus"></style>
